import { MapPin, ArrowRight } from "lucide-react";
import { Reveal, scrollToSection } from "@/components/Reveal";

const EVENTS = [
  { month: "TBA", day: "—", year: "2026", title: "Youth Mentorship Cohort Launch", where: "Location to be announced", tag: "Planned" },
  { month: "TBA", day: "—", year: "2026", title: "After-School Academic Enrichment Sessions", where: "Partner school sites TBA", tag: "Planned" },
  { month: "TBA", day: "—", year: "2026", title: "Athletic Development & Conditioning Camp", where: "Location to be announced", tag: "Planned" },
  { month: "TBA", day: "—", year: "2027", title: "College & Career Exposure Tour", where: "Regional campuses TBA", tag: "Planned" },
];

export const Events = () => (
  <section id="events" className="py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 bg-[#0C0C12] border-y border-[#242436]" data-testid="events-section">
    <Reveal>
      <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-[#FFB800] mb-4">The Roadmap</div>
      <h2 className="font-display font-black uppercase tracking-tight leading-none text-3xl sm:text-4xl lg:text-6xl text-[#F4F4F6]">
        Planned programming. <span className="text-outline">Real commitment.</span>
      </h2>
      <p className="mt-6 max-w-2xl text-sm sm:text-base leading-relaxed text-[#A1A1B3]">
        These launches are in active planning — dates and venues will be announced as they are
        confirmed. Reach out below to get notified or partner with us.
      </p>
    </Reveal>

    <div className="mt-16 space-y-4">
      {EVENTS.map((e, i) => (
        <Reveal key={e.title} delay={i * 0.07}>
          <div
            className="group flex flex-col sm:flex-row sm:items-center gap-5 border border-[#242436] hover:border-[#8B5CF6]/50 bg-[#111118] hover:bg-[#161622] transition-colors duration-300 p-6"
            data-testid={`event-card-${i}`}
          >
            <div className="flex items-center gap-4 shrink-0">
              <div className="w-20 text-center border border-[#3D3D58] group-hover:border-[#8B5CF6] transition-colors duration-300 py-3">
                <div className="font-mono text-xs tracking-[0.2em] text-[#FFB800]">{e.month}</div>
                <div className="font-display font-black text-3xl text-[#F4F4F6] leading-none mt-1">{e.day}</div>
                <div className="font-mono text-[10px] text-[#62627A] mt-1">{e.year}</div>
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00E5FF]">{e.tag}</span>
              <h3 className="font-display font-bold uppercase tracking-wide text-xl sm:text-2xl text-[#F4F4F6] mt-1">{e.title}</h3>
              <div className="flex items-center gap-2 mt-2 text-[#62627A]">
                <MapPin className="w-3.5 h-3.5" />
                <span className="font-mono text-xs uppercase tracking-[0.15em]">{e.where}</span>
              </div>
            </div>
            <button
              onClick={() => scrollToSection("#contact")}
              data-testid={`event-rsvp-${i}`}
              className="shrink-0 flex items-center gap-2 font-display font-bold uppercase tracking-wider text-sm border border-[#3D3D58] text-[#F4F4F6] px-5 py-2.5 hover:bg-[#8B5CF6] hover:text-black hover:border-[#8B5CF6] active:scale-95 transition-all duration-200"
            >
              RSVP
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
